export default [
  {
    path: "/raporkampanya",
    name: "raporkampanya",
    component: () => import("./index.vue"),
    meta: {
      public: false,
      title: "raporkampanya.Baslik",
      yetki: { k: [2000702] },
    },
  },
]
